import React, { useEffect, useState, useRef, memo } from 'react';
import './css/style.scss';
import { CgArrowLongRight } from '../../../../components/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
import { specialityPopOver } from '../../../../common/common';
import ShareCard from '../../../ShareCard';
import LazyImage from '../../../CustomLibraries/LazyImage';
import { toast } from 'react-toastify';
import useRedirect from '../../../customHooks/useRedirect';
// import reactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../../common/common';

import DoctorsSectionForCard from '../../../DoctorSectionForCard/DoctorsSectionForCard';
import { grand_rounds_static_image } from '../../../../common/assets.common';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';
import InView from 'react-intersection-observer';
// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);

const GrCardV1 = ({ cardData = '', hideImage = false, click, gtmTagVariable = '' }) => {
  const [grCardV1DocArea, setGrCardV1DocArea] = useState({
    height: 0,
    width: 0
  });
  // console.log('cardData', cardData);
  const { redirectTo } = useRedirect();
  const [grCardDoc, setGrCardDoc] = useState({ height: 0, width: 0 });
  const [last_circle, setLastCircle] = useState(-1);
  const [isHoverd, setIsHoverd] = useState(false);
  // const [activeHover, setActiveHover] = useState(false);

  let sponsorLogo = cardData?.sponsor_logo ? cardData?.sponsor_logo.split(',') : [];

  let grCardV1DocShowArea = useRef();
  let grCardV1Doc = useRef();
  const cardClick = () =>
    click ? click() : redirectTo('GrandRoundDetails', cardData.type_id, cardData.title);
  const shareClick = () => { };
  const getCardSize = () => {
    if (grCardV1DocShowArea.current || grCardV1Doc.current) {
      const areaWidth = grCardV1DocShowArea.current ? grCardV1DocShowArea.current.clientWidth : 0;
      const areaHeight = grCardV1DocShowArea.current ? grCardV1DocShowArea.current.clientHeight : 0;

      const docWidth = grCardV1Doc.current ? grCardV1Doc.current.clientWidth : 0;
      const docHeight = grCardV1Doc.current ? grCardV1Doc.current.clientHeight : 0;

      setGrCardV1DocArea({ height: areaHeight, width: areaWidth });
      setGrCardDoc({ height: docWidth, width: docHeight });
      console.log('last circle' + Math.floor(areaWidth / docWidth));
      setLastCircle(Math.floor(areaWidth / docWidth));
    }
  };

  useEffect(() => {
    // let box_area = document.querySelector(".grandround_area_" + cardData.type_id);
    // let doc_card = document.querySelector(".grCardV1Doc");
    // const prnWidth = box_area.offsetWidth;
    // const boxWidth = doc_card.offsetWidth;
    // const rounValue = Math.floor(prnWidth / boxWidth);
    // if (rounValue && rounValue > 0) {
    //   setLastCircle(rounValue)
    // }

    if (cardData) {
      const prnWidth = document.querySelector('.grandround_area_' + cardData.type_id)?.clientWidth;
      var boxWidth = document.querySelector('.grCardV1Doc')?.clientWidth;
      var rounValue = Math.floor(prnWidth / boxWidth);
      setLastCircle(rounValue);
    }
  }, [cardData]);

  const { userActivityTracker } = useTrackUserActivity();
  return (
    <InView
      as="div"
      className="w-100 float-start grCardV1Box bg-white shadow rounded-3 position-relative overflow-hidden"
      onChange={(inView) => {
        userActivityTracker(inView, { type: 'gr', ...cardData }, 'card');
      }}
    >
      <span
        className="graph-1 position-absolute start-0 bottom-0"
        style={{ backgroundColor: cardData?.color ?? '#22a5f8' }}
      ></span>
      <span
        className="graph-2 position-absolute start-0 bottom-0"
        style={{ backgroundColor: cardData?.color ?? '#22a5f8' }}
      ></span>
      {hideImage ? null : (
        <div
          className="w-100 float-start grCardV1BoxPic position-relative overflow-hidden cursorPointer"
          onClick={cardClick}
        >
          <LazyImage
            src={cardData?.image ?? grand_rounds_static_image}
            alt="banner"
            extraClass={'w-100 h-auto position-relative'}
            className={`object-fit-cover w-100 h-100 float-start gtm_cl_grCard`}
            fallback_image={grand_rounds_static_image}
          // id={`${gtmTagVariable}_image_${cardData.type_id}`}
          />
        </div>
      )}
      <div className="w-100 float-start grCrdV1Btm pt-3 pe-3 pb-4 ps-0">
        <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2 py-1 px-3 px-lg-4 pe-0">
          <span
            className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y h-100"
            style={{ backgroundColor: cardData?.color ?? '#22a5f8' }}
          ></span>
          <div className="text-black crdV1Speclty d-flex">
            <span
              className={`fs-4 ${hideImage === true ? '' : 'cursorPointer'} gtm_cl_grCard`}
              // id={`${gtmTagVariable}_grCard_specialities_${cardData.type_id}`}
              onClick={() => {
                if (cardData?.specialities_ids_and_names) {
                  redirectTo(
                    'Speciality',
                    cardData?.specialities_ids_and_names[0]?.id,
                    cardData?.specialities_ids_and_names[0]?.name
                  );
                }
              }}
            >
              {cardData && cardData?.specialities_ids_and_names?.length > 0
                ? cardData?.specialities_ids_and_names[0]?.name
                : ''}{' '}
            </span>

            {specialityPopOver(
              cardData?.specialities_ids_and_names?.map((speciality) => speciality.name).join(',')
            )}
          </div>
          <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
            <ShareCard
              gtmTagVariable={`gtm_cl_grCard_share`}
              // id={`${gtmTagVariable}_grCard_share`}
              shareClick={shareClick}
              data={{ title: cardData?.title, url: cardData?.deeplink }}
            />
          </a>
        </div>
        <div className="w-100 float-start d-flex text-start cardV1Topic ps-3 ps-lg-4 mb-2">
          {/* withChanel */}
          {/* <div className="rounded-circle overflow-hidden d-flex jsutify-content-center align-items-center border border-light cardV1ProfilePic">
            <img src="https://cdn5.vectorstock.com/i/1000x1000/75/49/minimalist-healthcare-or-medical-logo-design-image-vector-31927549.jpg" />
          </div> */}
          {/* withChanel */}

          <div className="cardV1TopicContent position-relative w-100 cursorPointer">
            <a
              href="javascript:void(0)"
              className={`text-black fs-16 line-clamp-3 fw-medium gtm_cl_grCard text-break`}
              onClick={cardClick}
            // id={`${gtmTagVariable}_grCard_title_${cardData.type_id}`}
            >
              {reactHtmlParser(cardData?.title)}
            </a>
            {/* <p className="text-dark fs-4">{cardData?.date}</p> */}
          </div>
        </div>
        <DoctorsSectionForCard type={'gr'} id={cardData?.type_id} cardData={cardData} />
        <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between ps-3 ps-lg-4 mt-2">
          {/* sponser logo if single ==========*/}
          {sponsorLogo.length == 1 && (
            <div className="crdV1sponser m-0 text-start">
              <div className="crdV1sponserIn w-100 bg-white position-relative">
                <LazyImage
                  src={sponsorLogo[0]}
                  className="position-absolute start-0 top-50 translate-middle-y"
                  alt="sponsor"
                  logo
                />
              </div>
            </div>
          )}
          {sponsorLogo.length == 0 && (
            <div className="crdV1sponser m-0 text-start">
              <div className="crdV1sponserIn w-100 bg-white position-relative"></div>
            </div>
          )}
          {/* sponser logo if single */}

          {/* sponser logo if multiple */}
          {sponsorLogo.length > 1 && (
            <Swiper
              className="crdV1sponser m-0 text-start"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect={'fade'}
            >
              {sponsorLogo.map((logo, _i) => (
                <SwiperSlide
                  className="crdV1sponserIn w-100 bg-white position-relative"
                  key={_i + 1}
                >
                  <LazyImage
                    src={logo}
                    className="position-absolute start-0 top-50 translate-middle-y"
                    alt="sponsor"
                    logo
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          <button
            className={`cardV1FtrBtn d-inline-block overflow-hidden py-3 px-4 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_grCard`}
            onClick={cardClick}
            onMouseEnter={() => {
              setIsHoverd(true);
            }}
            onMouseLeave={() => {
              setIsHoverd(false);
            }}
            style={{
              border: `${isHoverd
                  ? '1px solid transparent'
                  : `1px solid ${cardData?.color && cardData?.color !== '0' ? cardData?.color : '#22a5f8'
                  }`
                }`,
              // color: `${isHoverd && activeHover ? '#fff' : cardData?.color ?? '#22a5f8'}`,
              backgroundColor: `${isHoverd
                  ? cardData?.color && cardData?.color !== '0'
                    ? cardData?.color
                    : '#22a5f8'
                  : 'transparent'
                }`
            }}
          >
            {/* <div
              className={`cardV1BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_grCard`}
              style={{ backgroundColor: cardData?.color ?? '#22a5f8' }}
            ></div>
            <div
              className={`cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_grCard`}
              style={{ borderColor: cardData?.color ?? '#22a5f8' }}
            ></div> */}
            <span
              className={`position-relative z-1 gtm_cl_grCard d-flex align-items-center fs-4 gap-1`}
              style={{
                color: `${isHoverd
                    ? '#fff'
                    : cardData?.color && cardData?.color !== '0'
                      ? cardData?.color
                      : '#22a5f8'
                  }`
              }}
            >
              View Details{' '}
              <CgArrowLongRight customClass="fs-5 ms-1" gtmTagVariable={`gtm_cl_grCard`} />
            </span>
          </button>
        </div>
      </div>
    </InView>
  );
};
export default memo(GrCardV1);
